<template>
  <div class="view_stamp">
    <!-- 헤더 -->
    <Head type='back' name='view_stamp' :title='title()' />
    <div class="tour_sub_wrap">
      <StampSwiper v-if="imgArr.length" :image='imgArr' />
      <div v-else class="no_img">
        <div class="box">
          <img src="@/assets/images/img_nolist_img.png" alt="no_img">
          <p>이미지가 없습니다.</p>
        </div>
      </div>
      <StampInfo />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Head from '@/components/Head.vue'
import StampSwiper from '@/components/StampSwiper.vue'
import StampInfo from '@/components/StampInfo.vue'
export default {
  name: 'Stamp',
  components: {
    Head,
    StampSwiper,
    StampInfo
  },
  data () {
    return {
      imgArr: []
    }
  },
  computed: {
    ...mapState(['stampDataNew', 'loadingBar'])
  },
  watch: {
    stampDataNew () {
      if (this.stampDataNew.tour_image && this.stampDataNew.tour_image.length) {
        this.imgArr = this.stampDataNew.tour_image.map((val) => val.image_url)
      } else if (this.stampDataNew.poi_image.length) {
        this.imgArr = this.stampDataNew.poi_image
      }
    }
  },
  methods: {
    title () {
      return this.stampDataNew.title || this.stampDataNew.mingle_poi_main_title || '정보 없음'
    }
  },
  beforeCreate () {
    if (this.$route.query.mingleCode) {
      this.$cookie.set('service_code', this.$route.query.mingleCode, 9999)
      this.$store.dispatch('setMingleCode', this.$cookie.get('service_code'))
    }
  },
  mounted () {
    this.$store.state.loadingBar = true
    this.$store.dispatch('loadStampDataNew', {
      mingleCode: this.$cookie.get('service_code'),
      mingle_badge_id: this.$route.query.badge_id,
      content_type_id: this.$route.query.contentTypeId || 1,
      content_id: this.$route.query.contentId || 1,
      poi_no: this.$route.query.mingle_poi_no || ''
    })
  },
  destroyed () {
    this.$store.state.stampDataNew = {}
  }
}
</script>
